var _rect, _rect2, _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7, _circle8, _circle9, _circle10, _circle11, _circle12, _circle13, _circle14, _circle15, _circle16, _circle17, _circle18, _circle19, _circle20, _circle21, _circle22, _circle23, _circle24, _circle25, _circle26, _circle27, _circle28, _circle29, _circle30, _circle31, _circle32, _circle33, _circle34, _circle35, _circle36, _circle37, _circle38, _circle39, _circle40, _circle41, _circle42, _circle43, _circle44, _circle45, _circle46, _circle47, _circle48, _circle49, _circle50, _circle51, _circle52, _circle53, _circle54, _circle55, _circle56, _circle57, _circle58, _circle59, _circle60, _circle61, _circle62, _circle63, _circle64, _circle65, _circle66, _circle67, _circle68, _circle69, _circle70, _circle71, _circle72, _circle73, _circle74, _circle75, _circle76, _circle77, _circle78, _circle79, _circle80, _circle81, _circle82, _circle83, _circle84, _circle85, _circle86, _circle87, _circle88, _circle89, _circle90, _circle91, _circle92, _circle93, _circle94, _circle95, _circle96, _circle97, _circle98, _circle99, _circle100, _circle101, _circle102, _circle103, _circle104, _circle105, _circle106, _circle107, _circle108, _circle109, _circle110, _circle111, _circle112, _circle113, _circle114, _circle115, _circle116, _circle117, _circle118, _circle119, _circle120, _circle121, _circle122, _circle123, _circle124, _circle125, _circle126, _circle127, _circle128, _circle129, _circle130, _circle131, _circle132, _circle133, _circle134, _circle135, _circle136, _circle137, _circle138, _circle139, _circle140, _circle141, _circle142, _circle143, _circle144, _circle145, _circle146, _circle147, _circle148, _circle149, _circle150, _circle151, _circle152, _circle153, _circle154, _circle155, _circle156, _circle157, _circle158, _circle159, _circle160, _circle161, _circle162, _circle163, _circle164, _circle165, _circle166, _circle167, _circle168, _circle169, _circle170, _circle171, _circle172, _circle173, _circle174, _circle175, _circle176, _circle177, _circle178, _circle179, _circle180, _circle181, _circle182, _circle183, _circle184, _circle185, _circle186, _circle187, _circle188, _circle189, _circle190, _circle191, _circle192, _circle193, _circle194, _circle195, _circle196, _circle197, _circle198, _circle199, _circle200, _circle201, _circle202, _circle203, _circle204, _circle205, _circle206, _circle207, _circle208, _circle209, _circle210, _circle211, _circle212, _circle213, _circle214, _circle215, _circle216, _circle217, _circle218, _circle219, _circle220, _circle221, _circle222, _circle223, _circle224, _circle225, _circle226, _circle227, _circle228, _circle229, _circle230, _circle231, _circle232, _circle233, _circle234, _circle235, _circle236, _circle237, _circle238, _circle239, _circle240, _circle241, _circle242, _circle243, _circle244, _circle245, _circle246, _circle247, _circle248, _circle249, _circle250, _circle251, _circle252, _circle253, _circle254, _circle255, _circle256, _circle257, _circle258, _circle259, _circle260, _circle261, _circle262, _circle263, _circle264, _circle265, _circle266, _circle267, _circle268, _circle269, _circle270, _circle271, _circle272, _circle273, _circle274, _circle275, _circle276, _circle277, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12, _rect13, _rect14, _rect15, _rect16, _rect17, _rect18, _rect19, _rect20, _rect21, _rect22, _rect23, _rect24, _rect25, _rect26, _rect27, _rect28, _rect29, _rect30, _rect31, _rect32, _rect33, _rect34, _rect35, _rect36, _rect37, _rect38, _rect39, _rect40, _rect41, _rect42, _rect43, _rect44, _rect45, _rect46, _rect47, _rect48, _rect49, _rect50, _rect51, _rect52, _rect53, _rect54, _rect55, _rect56, _rect57, _rect58, _rect59, _rect60, _rect61, _rect62, _rect63, _rect64, _rect65, _rect66, _rect67, _rect68, _rect69, _rect70, _rect71, _rect72, _rect73, _rect74, _rect75, _rect76, _rect77, _rect78, _rect79, _rect80, _rect81, _rect82, _rect83, _rect84, _rect85, _rect86, _rect87, _rect88, _rect89, _rect90, _rect91, _rect92, _rect93, _rect94, _rect95, _rect96, _rect97, _rect98, _rect99, _rect100, _rect101, _rect102, _rect103, _rect104, _rect105, _rect106, _rect107, _rect108, _rect109, _rect110, _rect111, _rect112, _rect113, _rect114, _rect115, _rect116, _rect117, _rect118, _rect119, _circle278, _circle279, _circle280, _circle281, _path, _path2, _g, _path3, _g2, _path4, _g3, _path5, _g4, _path6, _g5, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInnovly(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 280,
    height: 279,
    viewBox: "0 0 280 279",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1_999)"
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 32.5,
    y: 20.5,
    width: 215,
    height: 214,
    rx: 8.5,
    fill: "white",
    stroke: "#F5CA2F"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 60,
    y: 48,
    width: 160,
    height: 161,
    rx: 9,
    fill: "url(#paint0_radial_1_999)",
    fillOpacity: 0.7
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 95.5,
    cy: 56.5,
    r: 0.5,
    fill: "black",
    fillOpacity: 0.1
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 104.5,
    cy: 56.5,
    r: 0.5,
    fill: "black",
    fillOpacity: 0.1
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 113.5,
    cy: 56.5,
    r: 0.5,
    fill: "black",
    fillOpacity: 0.1
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 122.5,
    cy: 56.5,
    r: 0.5,
    fill: "black",
    fillOpacity: 0.1
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 131.5,
    cy: 56.5,
    r: 0.5,
    fill: "black",
    fillOpacity: 0.1
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 140.5,
    cy: 56.5,
    r: 0.5,
    fill: "black",
    fillOpacity: 0.1
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 149.5,
    cy: 56.5,
    r: 0.5,
    fill: "black",
    fillOpacity: 0.1
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 158.5,
    cy: 56.5,
    r: 0.5,
    fill: "black",
    fillOpacity: 0.1
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 167.5,
    cy: 56.5,
    r: 0.5,
    fill: "black",
    fillOpacity: 0.1
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    cx: 176.5,
    cy: 56.5,
    r: 0.5,
    fill: "black",
    fillOpacity: 0.1
  })), _circle11 || (_circle11 = /*#__PURE__*/React.createElement("circle", {
    cx: 185.5,
    cy: 56.5,
    r: 0.5,
    fill: "black",
    fillOpacity: 0.1
  })), _circle12 || (_circle12 = /*#__PURE__*/React.createElement("circle", {
    cx: 194.5,
    cy: 56.5,
    r: 0.5,
    fill: "black",
    fillOpacity: 0.1
  })), _circle13 || (_circle13 = /*#__PURE__*/React.createElement("circle", {
    cx: 203.5,
    cy: 56.5,
    r: 0.5,
    fill: "black",
    fillOpacity: 0.1
  })), _circle14 || (_circle14 = /*#__PURE__*/React.createElement("circle", {
    cx: 95.5,
    cy: 65.5,
    r: 0.5,
    fill: "black",
    fillOpacity: 0.1
  })), _circle15 || (_circle15 = /*#__PURE__*/React.createElement("circle", {
    cx: 104.5,
    cy: 65.5,
    r: 0.5,
    fill: "black",
    fillOpacity: 0.1
  })), _circle16 || (_circle16 = /*#__PURE__*/React.createElement("circle", {
    cx: 113.5,
    cy: 65.5,
    r: 0.5,
    fill: "black",
    fillOpacity: 0.1
  })), _circle17 || (_circle17 = /*#__PURE__*/React.createElement("circle", {
    cx: 122.5,
    cy: 65.5,
    r: 0.5,
    fill: "black",
    fillOpacity: 0.1
  })), _circle18 || (_circle18 = /*#__PURE__*/React.createElement("circle", {
    cx: 131.5,
    cy: 65.5,
    r: 0.5,
    fill: "black",
    fillOpacity: 0.1
  })), _circle19 || (_circle19 = /*#__PURE__*/React.createElement("circle", {
    cx: 140.5,
    cy: 65.5,
    r: 0.5,
    fill: "black",
    fillOpacity: 0.1
  })), _circle20 || (_circle20 = /*#__PURE__*/React.createElement("circle", {
    cx: 149.5,
    cy: 65.5,
    r: 0.5,
    fill: "black",
    fillOpacity: 0.1
  })), _circle21 || (_circle21 = /*#__PURE__*/React.createElement("circle", {
    cx: 158.5,
    cy: 65.5,
    r: 0.5,
    fill: "black",
    fillOpacity: 0.1
  })), _circle22 || (_circle22 = /*#__PURE__*/React.createElement("circle", {
    cx: 167.5,
    cy: 65.5,
    r: 0.5,
    fill: "black",
    fillOpacity: 0.1
  })), _circle23 || (_circle23 = /*#__PURE__*/React.createElement("circle", {
    cx: 176.5,
    cy: 65.5,
    r: 0.5,
    fill: "black",
    fillOpacity: 0.1
  })), _circle24 || (_circle24 = /*#__PURE__*/React.createElement("circle", {
    cx: 185.5,
    cy: 65.5,
    r: 0.5,
    fill: "black",
    fillOpacity: 0.1
  })), _circle25 || (_circle25 = /*#__PURE__*/React.createElement("circle", {
    cx: 194.5,
    cy: 65.5,
    r: 0.5,
    fill: "black",
    fillOpacity: 0.1
  })), _circle26 || (_circle26 = /*#__PURE__*/React.createElement("circle", {
    cx: 203.5,
    cy: 65.5,
    r: 0.5,
    fill: "black",
    fillOpacity: 0.1
  })), _circle27 || (_circle27 = /*#__PURE__*/React.createElement("circle", {
    cx: 95.5,
    cy: 74.5,
    r: 0.5,
    fill: "black",
    fillOpacity: 0.1
  })), _circle28 || (_circle28 = /*#__PURE__*/React.createElement("circle", {
    cx: 104.5,
    cy: 74.5,
    r: 0.5,
    fill: "black",
    fillOpacity: 0.1
  })), _circle29 || (_circle29 = /*#__PURE__*/React.createElement("circle", {
    cx: 113.5,
    cy: 74.5,
    r: 0.5,
    fill: "black",
    fillOpacity: 0.1
  })), _circle30 || (_circle30 = /*#__PURE__*/React.createElement("circle", {
    cx: 122.5,
    cy: 74.5,
    r: 0.5,
    fill: "black",
    fillOpacity: 0.1
  })), _circle31 || (_circle31 = /*#__PURE__*/React.createElement("circle", {
    cx: 131.5,
    cy: 74.5,
    r: 0.5,
    fill: "black",
    fillOpacity: 0.1
  })), _circle32 || (_circle32 = /*#__PURE__*/React.createElement("circle", {
    cx: 140.5,
    cy: 74.5,
    r: 0.5,
    fill: "black",
    fillOpacity: 0.1
  })), _circle33 || (_circle33 = /*#__PURE__*/React.createElement("circle", {
    cx: 149.5,
    cy: 74.5,
    r: 0.5,
    fill: "black",
    fillOpacity: 0.1
  })), _circle34 || (_circle34 = /*#__PURE__*/React.createElement("circle", {
    cx: 158.5,
    cy: 74.5,
    r: 0.5,
    fill: "black",
    fillOpacity: 0.1
  })), _circle35 || (_circle35 = /*#__PURE__*/React.createElement("circle", {
    cx: 167.5,
    cy: 74.5,
    r: 0.5,
    fill: "black",
    fillOpacity: 0.1
  })), _circle36 || (_circle36 = /*#__PURE__*/React.createElement("circle", {
    cx: 176.5,
    cy: 74.5,
    r: 0.5,
    fill: "black",
    fillOpacity: 0.1
  })), _circle37 || (_circle37 = /*#__PURE__*/React.createElement("circle", {
    cx: 185.5,
    cy: 74.5,
    r: 0.5,
    fill: "black",
    fillOpacity: 0.1
  })), _circle38 || (_circle38 = /*#__PURE__*/React.createElement("circle", {
    cx: 194.5,
    cy: 74.5,
    r: 0.5,
    fill: "black",
    fillOpacity: 0.1
  })), _circle39 || (_circle39 = /*#__PURE__*/React.createElement("circle", {
    cx: 203.5,
    cy: 74.5,
    r: 0.5,
    fill: "black",
    fillOpacity: 0.1
  })), _circle40 || (_circle40 = /*#__PURE__*/React.createElement("circle", {
    cx: 68.5,
    cy: 83.5,
    r: 0.5,
    fill: "black",
    fillOpacity: 0.1
  })), _circle41 || (_circle41 = /*#__PURE__*/React.createElement("circle", {
    cx: 77.5,
    cy: 83.5,
    r: 0.5,
    fill: "black",
    fillOpacity: 0.1
  })), _circle42 || (_circle42 = /*#__PURE__*/React.createElement("circle", {
    cx: 86.5,
    cy: 83.5,
    r: 0.5,
    fill: "black",
    fillOpacity: 0.1
  })), _circle43 || (_circle43 = /*#__PURE__*/React.createElement("circle", {
    cx: 95.5,
    cy: 83.5,
    r: 0.5,
    fill: "black",
    fillOpacity: 0.1
  })), _circle44 || (_circle44 = /*#__PURE__*/React.createElement("circle", {
    cx: 104.5,
    cy: 83.5,
    r: 0.5,
    fill: "black",
    fillOpacity: 0.1
  })), _circle45 || (_circle45 = /*#__PURE__*/React.createElement("circle", {
    cx: 113.5,
    cy: 83.5,
    r: 0.5,
    fill: "black",
    fillOpacity: 0.1
  })), _circle46 || (_circle46 = /*#__PURE__*/React.createElement("circle", {
    cx: 122.5,
    cy: 83.5,
    r: 0.5,
    fill: "black",
    fillOpacity: 0.1
  })), _circle47 || (_circle47 = /*#__PURE__*/React.createElement("circle", {
    cx: 131.5,
    cy: 83.5,
    r: 0.5,
    fill: "black",
    fillOpacity: 0.1
  })), _circle48 || (_circle48 = /*#__PURE__*/React.createElement("circle", {
    cx: 140.5,
    cy: 83.5,
    r: 0.5,
    fill: "black",
    fillOpacity: 0.1
  })), _circle49 || (_circle49 = /*#__PURE__*/React.createElement("circle", {
    cx: 149.5,
    cy: 83.5,
    r: 0.5,
    fill: "black",
    fillOpacity: 0.1
  })), _circle50 || (_circle50 = /*#__PURE__*/React.createElement("circle", {
    cx: 158.5,
    cy: 83.5,
    r: 0.5,
    fill: "black",
    fillOpacity: 0.1
  })), _circle51 || (_circle51 = /*#__PURE__*/React.createElement("circle", {
    cx: 167.5,
    cy: 83.5,
    r: 0.5,
    fill: "black",
    fillOpacity: 0.1
  })), _circle52 || (_circle52 = /*#__PURE__*/React.createElement("circle", {
    cx: 176.5,
    cy: 83.5,
    r: 0.5,
    fill: "black",
    fillOpacity: 0.1
  })), _circle53 || (_circle53 = /*#__PURE__*/React.createElement("circle", {
    cx: 185.5,
    cy: 83.5,
    r: 0.5,
    fill: "black",
    fillOpacity: 0.1
  })), _circle54 || (_circle54 = /*#__PURE__*/React.createElement("circle", {
    cx: 194.5,
    cy: 83.5,
    r: 0.5,
    fill: "black",
    fillOpacity: 0.1
  })), _circle55 || (_circle55 = /*#__PURE__*/React.createElement("circle", {
    cx: 203.5,
    cy: 83.5,
    r: 0.5,
    fill: "black",
    fillOpacity: 0.1
  })), _circle56 || (_circle56 = /*#__PURE__*/React.createElement("circle", {
    cx: 212.5,
    cy: 83.5,
    r: 0.5,
    fill: "black",
    fillOpacity: 0.1
  })), _circle57 || (_circle57 = /*#__PURE__*/React.createElement("circle", {
    cx: 68.5,
    cy: 92.5,
    r: 0.5,
    fill: "black",
    fillOpacity: 0.1
  })), _circle58 || (_circle58 = /*#__PURE__*/React.createElement("circle", {
    cx: 77.5,
    cy: 92.5,
    r: 0.5,
    fill: "black",
    fillOpacity: 0.1
  })), _circle59 || (_circle59 = /*#__PURE__*/React.createElement("circle", {
    cx: 86.5,
    cy: 92.5,
    r: 0.5,
    fill: "black",
    fillOpacity: 0.1
  })), _circle60 || (_circle60 = /*#__PURE__*/React.createElement("circle", {
    cx: 95.5,
    cy: 92.5,
    r: 0.5,
    fill: "black",
    fillOpacity: 0.1
  })), _circle61 || (_circle61 = /*#__PURE__*/React.createElement("circle", {
    cx: 104.5,
    cy: 92.5,
    r: 0.5,
    fill: "black",
    fillOpacity: 0.1
  })), _circle62 || (_circle62 = /*#__PURE__*/React.createElement("circle", {
    cx: 113.5,
    cy: 92.5,
    r: 0.5,
    fill: "black",
    fillOpacity: 0.1
  })), _circle63 || (_circle63 = /*#__PURE__*/React.createElement("circle", {
    cx: 122.5,
    cy: 92.5,
    r: 0.5,
    fill: "black",
    fillOpacity: 0.1
  })), _circle64 || (_circle64 = /*#__PURE__*/React.createElement("circle", {
    cx: 131.5,
    cy: 92.5,
    r: 0.5,
    fill: "black",
    fillOpacity: 0.1
  })), _circle65 || (_circle65 = /*#__PURE__*/React.createElement("circle", {
    cx: 140.5,
    cy: 92.5,
    r: 0.5,
    fill: "black",
    fillOpacity: 0.1
  })), _circle66 || (_circle66 = /*#__PURE__*/React.createElement("circle", {
    cx: 149.5,
    cy: 92.5,
    r: 0.5,
    fill: "black",
    fillOpacity: 0.1
  })), _circle67 || (_circle67 = /*#__PURE__*/React.createElement("circle", {
    cx: 158.5,
    cy: 92.5,
    r: 0.5,
    fill: "black",
    fillOpacity: 0.1
  })), _circle68 || (_circle68 = /*#__PURE__*/React.createElement("circle", {
    cx: 167.5,
    cy: 92.5,
    r: 0.5,
    fill: "black",
    fillOpacity: 0.1
  })), _circle69 || (_circle69 = /*#__PURE__*/React.createElement("circle", {
    cx: 176.5,
    cy: 92.5,
    r: 0.5,
    fill: "black",
    fillOpacity: 0.1
  })), _circle70 || (_circle70 = /*#__PURE__*/React.createElement("circle", {
    cx: 185.5,
    cy: 92.5,
    r: 0.5,
    fill: "black",
    fillOpacity: 0.1
  })), _circle71 || (_circle71 = /*#__PURE__*/React.createElement("circle", {
    cx: 194.5,
    cy: 92.5,
    r: 0.5,
    fill: "black",
    fillOpacity: 0.1
  })), _circle72 || (_circle72 = /*#__PURE__*/React.createElement("circle", {
    cx: 203.5,
    cy: 92.5,
    r: 0.5,
    fill: "black",
    fillOpacity: 0.1
  })), _circle73 || (_circle73 = /*#__PURE__*/React.createElement("circle", {
    cx: 212.5,
    cy: 92.5,
    r: 0.5,
    fill: "black",
    fillOpacity: 0.1
  })), _circle74 || (_circle74 = /*#__PURE__*/React.createElement("circle", {
    cx: 68.5,
    cy: 101.5,
    r: 0.5,
    fill: "black",
    fillOpacity: 0.1
  })), _circle75 || (_circle75 = /*#__PURE__*/React.createElement("circle", {
    cx: 77.5,
    cy: 101.5,
    r: 0.5,
    fill: "black",
    fillOpacity: 0.1
  })), _circle76 || (_circle76 = /*#__PURE__*/React.createElement("circle", {
    cx: 86.5,
    cy: 101.5,
    r: 0.5,
    fill: "black",
    fillOpacity: 0.1
  })), _circle77 || (_circle77 = /*#__PURE__*/React.createElement("circle", {
    cx: 95.5,
    cy: 101.5,
    r: 0.5,
    fill: "black",
    fillOpacity: 0.1
  })), _circle78 || (_circle78 = /*#__PURE__*/React.createElement("circle", {
    cx: 104.5,
    cy: 101.5,
    r: 0.5,
    fill: "black",
    fillOpacity: 0.1
  })), _circle79 || (_circle79 = /*#__PURE__*/React.createElement("circle", {
    cx: 113.5,
    cy: 101.5,
    r: 0.5,
    fill: "black",
    fillOpacity: 0.1
  })), _circle80 || (_circle80 = /*#__PURE__*/React.createElement("circle", {
    cx: 122.5,
    cy: 101.5,
    r: 0.5,
    fill: "black",
    fillOpacity: 0.1
  })), _circle81 || (_circle81 = /*#__PURE__*/React.createElement("circle", {
    cx: 131.5,
    cy: 101.5,
    r: 0.5,
    fill: "black",
    fillOpacity: 0.1
  })), _circle82 || (_circle82 = /*#__PURE__*/React.createElement("circle", {
    cx: 140.5,
    cy: 101.5,
    r: 0.5,
    fill: "black",
    fillOpacity: 0.1
  })), _circle83 || (_circle83 = /*#__PURE__*/React.createElement("circle", {
    cx: 149.5,
    cy: 101.5,
    r: 0.5,
    fill: "black",
    fillOpacity: 0.1
  })), _circle84 || (_circle84 = /*#__PURE__*/React.createElement("circle", {
    cx: 158.5,
    cy: 101.5,
    r: 0.5,
    fill: "black",
    fillOpacity: 0.1
  })), _circle85 || (_circle85 = /*#__PURE__*/React.createElement("circle", {
    cx: 167.5,
    cy: 101.5,
    r: 0.5,
    fill: "black",
    fillOpacity: 0.1
  })), _circle86 || (_circle86 = /*#__PURE__*/React.createElement("circle", {
    cx: 176.5,
    cy: 101.5,
    r: 0.5,
    fill: "black",
    fillOpacity: 0.1
  })), _circle87 || (_circle87 = /*#__PURE__*/React.createElement("circle", {
    cx: 185.5,
    cy: 101.5,
    r: 0.5,
    fill: "black",
    fillOpacity: 0.1
  })), _circle88 || (_circle88 = /*#__PURE__*/React.createElement("circle", {
    cx: 194.5,
    cy: 101.5,
    r: 0.5,
    fill: "black",
    fillOpacity: 0.1
  })), _circle89 || (_circle89 = /*#__PURE__*/React.createElement("circle", {
    cx: 203.5,
    cy: 101.5,
    r: 0.5,
    fill: "black",
    fillOpacity: 0.1
  })), _circle90 || (_circle90 = /*#__PURE__*/React.createElement("circle", {
    cx: 212.5,
    cy: 101.5,
    r: 0.5,
    fill: "black",
    fillOpacity: 0.1
  })), _circle91 || (_circle91 = /*#__PURE__*/React.createElement("circle", {
    cx: 68.5,
    cy: 110.5,
    r: 0.5,
    fill: "black",
    fillOpacity: 0.1
  })), _circle92 || (_circle92 = /*#__PURE__*/React.createElement("circle", {
    cx: 77.5,
    cy: 110.5,
    r: 0.5,
    fill: "black",
    fillOpacity: 0.1
  })), _circle93 || (_circle93 = /*#__PURE__*/React.createElement("circle", {
    cx: 86.5,
    cy: 110.5,
    r: 0.5,
    fill: "black",
    fillOpacity: 0.1
  })), _circle94 || (_circle94 = /*#__PURE__*/React.createElement("circle", {
    cx: 95.5,
    cy: 110.5,
    r: 0.5,
    fill: "black",
    fillOpacity: 0.1
  })), _circle95 || (_circle95 = /*#__PURE__*/React.createElement("circle", {
    cx: 104.5,
    cy: 110.5,
    r: 0.5,
    fill: "black",
    fillOpacity: 0.1
  })), _circle96 || (_circle96 = /*#__PURE__*/React.createElement("circle", {
    cx: 113.5,
    cy: 110.5,
    r: 0.5,
    fill: "black",
    fillOpacity: 0.1
  })), _circle97 || (_circle97 = /*#__PURE__*/React.createElement("circle", {
    cx: 122.5,
    cy: 110.5,
    r: 0.5,
    fill: "black",
    fillOpacity: 0.1
  })), _circle98 || (_circle98 = /*#__PURE__*/React.createElement("circle", {
    cx: 131.5,
    cy: 110.5,
    r: 0.5,
    fill: "black",
    fillOpacity: 0.1
  })), _circle99 || (_circle99 = /*#__PURE__*/React.createElement("circle", {
    cx: 140.5,
    cy: 110.5,
    r: 0.5,
    fill: "black",
    fillOpacity: 0.1
  })), _circle100 || (_circle100 = /*#__PURE__*/React.createElement("circle", {
    cx: 149.5,
    cy: 110.5,
    r: 0.5,
    fill: "black",
    fillOpacity: 0.1
  })), _circle101 || (_circle101 = /*#__PURE__*/React.createElement("circle", {
    cx: 158.5,
    cy: 110.5,
    r: 0.5,
    fill: "black",
    fillOpacity: 0.1
  })), _circle102 || (_circle102 = /*#__PURE__*/React.createElement("circle", {
    cx: 167.5,
    cy: 110.5,
    r: 0.5,
    fill: "black",
    fillOpacity: 0.1
  })), _circle103 || (_circle103 = /*#__PURE__*/React.createElement("circle", {
    cx: 176.5,
    cy: 110.5,
    r: 0.5,
    fill: "black",
    fillOpacity: 0.1
  })), _circle104 || (_circle104 = /*#__PURE__*/React.createElement("circle", {
    cx: 185.5,
    cy: 110.5,
    r: 0.5,
    fill: "black",
    fillOpacity: 0.1
  })), _circle105 || (_circle105 = /*#__PURE__*/React.createElement("circle", {
    cx: 194.5,
    cy: 110.5,
    r: 0.5,
    fill: "black",
    fillOpacity: 0.1
  })), _circle106 || (_circle106 = /*#__PURE__*/React.createElement("circle", {
    cx: 203.5,
    cy: 110.5,
    r: 0.5,
    fill: "black",
    fillOpacity: 0.1
  })), _circle107 || (_circle107 = /*#__PURE__*/React.createElement("circle", {
    cx: 212.5,
    cy: 110.5,
    r: 0.5,
    fill: "black",
    fillOpacity: 0.1
  })), _circle108 || (_circle108 = /*#__PURE__*/React.createElement("circle", {
    cx: 68.5,
    cy: 119.5,
    r: 0.5,
    fill: "black",
    fillOpacity: 0.1
  })), _circle109 || (_circle109 = /*#__PURE__*/React.createElement("circle", {
    cx: 77.5,
    cy: 119.5,
    r: 0.5,
    fill: "black",
    fillOpacity: 0.1
  })), _circle110 || (_circle110 = /*#__PURE__*/React.createElement("circle", {
    cx: 86.5,
    cy: 119.5,
    r: 0.5,
    fill: "black",
    fillOpacity: 0.1
  })), _circle111 || (_circle111 = /*#__PURE__*/React.createElement("circle", {
    cx: 95.5,
    cy: 119.5,
    r: 0.5,
    fill: "black",
    fillOpacity: 0.1
  })), _circle112 || (_circle112 = /*#__PURE__*/React.createElement("circle", {
    cx: 104.5,
    cy: 119.5,
    r: 0.5,
    fill: "black",
    fillOpacity: 0.1
  })), _circle113 || (_circle113 = /*#__PURE__*/React.createElement("circle", {
    cx: 113.5,
    cy: 119.5,
    r: 0.5,
    fill: "black",
    fillOpacity: 0.1
  })), _circle114 || (_circle114 = /*#__PURE__*/React.createElement("circle", {
    cx: 122.5,
    cy: 119.5,
    r: 0.5,
    fill: "black",
    fillOpacity: 0.1
  })), _circle115 || (_circle115 = /*#__PURE__*/React.createElement("circle", {
    cx: 131.5,
    cy: 119.5,
    r: 0.5,
    fill: "black",
    fillOpacity: 0.1
  })), _circle116 || (_circle116 = /*#__PURE__*/React.createElement("circle", {
    cx: 140.5,
    cy: 119.5,
    r: 0.5,
    fill: "black",
    fillOpacity: 0.1
  })), _circle117 || (_circle117 = /*#__PURE__*/React.createElement("circle", {
    cx: 149.5,
    cy: 119.5,
    r: 0.5,
    fill: "black",
    fillOpacity: 0.1
  })), _circle118 || (_circle118 = /*#__PURE__*/React.createElement("circle", {
    cx: 158.5,
    cy: 119.5,
    r: 0.5,
    fill: "black",
    fillOpacity: 0.1
  })), _circle119 || (_circle119 = /*#__PURE__*/React.createElement("circle", {
    cx: 167.5,
    cy: 119.5,
    r: 0.5,
    fill: "black",
    fillOpacity: 0.1
  })), _circle120 || (_circle120 = /*#__PURE__*/React.createElement("circle", {
    cx: 176.5,
    cy: 119.5,
    r: 0.5,
    fill: "black",
    fillOpacity: 0.1
  })), _circle121 || (_circle121 = /*#__PURE__*/React.createElement("circle", {
    cx: 185.5,
    cy: 119.5,
    r: 0.5,
    fill: "black",
    fillOpacity: 0.1
  })), _circle122 || (_circle122 = /*#__PURE__*/React.createElement("circle", {
    cx: 194.5,
    cy: 119.5,
    r: 0.5,
    fill: "black",
    fillOpacity: 0.1
  })), _circle123 || (_circle123 = /*#__PURE__*/React.createElement("circle", {
    cx: 203.5,
    cy: 119.5,
    r: 0.5,
    fill: "black",
    fillOpacity: 0.1
  })), _circle124 || (_circle124 = /*#__PURE__*/React.createElement("circle", {
    cx: 212.5,
    cy: 119.5,
    r: 0.5,
    fill: "black",
    fillOpacity: 0.1
  })), _circle125 || (_circle125 = /*#__PURE__*/React.createElement("circle", {
    cx: 68.5,
    cy: 128.5,
    r: 0.5,
    fill: "black",
    fillOpacity: 0.1
  })), _circle126 || (_circle126 = /*#__PURE__*/React.createElement("circle", {
    cx: 77.5,
    cy: 128.5,
    r: 0.5,
    fill: "black",
    fillOpacity: 0.1
  })), _circle127 || (_circle127 = /*#__PURE__*/React.createElement("circle", {
    cx: 86.5,
    cy: 128.5,
    r: 0.5,
    fill: "black",
    fillOpacity: 0.1
  })), _circle128 || (_circle128 = /*#__PURE__*/React.createElement("circle", {
    cx: 95.5,
    cy: 128.5,
    r: 0.5,
    fill: "black",
    fillOpacity: 0.1
  })), _circle129 || (_circle129 = /*#__PURE__*/React.createElement("circle", {
    cx: 104.5,
    cy: 128.5,
    r: 0.5,
    fill: "black",
    fillOpacity: 0.1
  })), _circle130 || (_circle130 = /*#__PURE__*/React.createElement("circle", {
    cx: 113.5,
    cy: 128.5,
    r: 0.5,
    fill: "black",
    fillOpacity: 0.1
  })), _circle131 || (_circle131 = /*#__PURE__*/React.createElement("circle", {
    cx: 122.5,
    cy: 128.5,
    r: 0.5,
    fill: "black",
    fillOpacity: 0.1
  })), _circle132 || (_circle132 = /*#__PURE__*/React.createElement("circle", {
    cx: 131.5,
    cy: 128.5,
    r: 0.5,
    fill: "black",
    fillOpacity: 0.1
  })), _circle133 || (_circle133 = /*#__PURE__*/React.createElement("circle", {
    cx: 140.5,
    cy: 128.5,
    r: 0.5,
    fill: "black",
    fillOpacity: 0.1
  })), _circle134 || (_circle134 = /*#__PURE__*/React.createElement("circle", {
    cx: 149.5,
    cy: 128.5,
    r: 0.5,
    fill: "black",
    fillOpacity: 0.1
  })), _circle135 || (_circle135 = /*#__PURE__*/React.createElement("circle", {
    cx: 158.5,
    cy: 128.5,
    r: 0.5,
    fill: "black",
    fillOpacity: 0.1
  })), _circle136 || (_circle136 = /*#__PURE__*/React.createElement("circle", {
    cx: 167.5,
    cy: 128.5,
    r: 0.5,
    fill: "black",
    fillOpacity: 0.1
  })), _circle137 || (_circle137 = /*#__PURE__*/React.createElement("circle", {
    cx: 176.5,
    cy: 128.5,
    r: 0.5,
    fill: "black",
    fillOpacity: 0.1
  })), _circle138 || (_circle138 = /*#__PURE__*/React.createElement("circle", {
    cx: 185.5,
    cy: 128.5,
    r: 0.5,
    fill: "black",
    fillOpacity: 0.1
  })), _circle139 || (_circle139 = /*#__PURE__*/React.createElement("circle", {
    cx: 194.5,
    cy: 128.5,
    r: 0.5,
    fill: "black",
    fillOpacity: 0.1
  })), _circle140 || (_circle140 = /*#__PURE__*/React.createElement("circle", {
    cx: 203.5,
    cy: 128.5,
    r: 0.5,
    fill: "black",
    fillOpacity: 0.1
  })), _circle141 || (_circle141 = /*#__PURE__*/React.createElement("circle", {
    cx: 212.5,
    cy: 128.5,
    r: 0.5,
    fill: "black",
    fillOpacity: 0.1
  })), _circle142 || (_circle142 = /*#__PURE__*/React.createElement("circle", {
    cx: 68.5,
    cy: 137.5,
    r: 0.5,
    fill: "black",
    fillOpacity: 0.1
  })), _circle143 || (_circle143 = /*#__PURE__*/React.createElement("circle", {
    cx: 77.5,
    cy: 137.5,
    r: 0.5,
    fill: "black",
    fillOpacity: 0.1
  })), _circle144 || (_circle144 = /*#__PURE__*/React.createElement("circle", {
    cx: 86.5,
    cy: 137.5,
    r: 0.5,
    fill: "black",
    fillOpacity: 0.1
  })), _circle145 || (_circle145 = /*#__PURE__*/React.createElement("circle", {
    cx: 95.5,
    cy: 137.5,
    r: 0.5,
    fill: "black",
    fillOpacity: 0.1
  })), _circle146 || (_circle146 = /*#__PURE__*/React.createElement("circle", {
    cx: 104.5,
    cy: 137.5,
    r: 0.5,
    fill: "black",
    fillOpacity: 0.1
  })), _circle147 || (_circle147 = /*#__PURE__*/React.createElement("circle", {
    cx: 113.5,
    cy: 137.5,
    r: 0.5,
    fill: "black",
    fillOpacity: 0.1
  })), _circle148 || (_circle148 = /*#__PURE__*/React.createElement("circle", {
    cx: 122.5,
    cy: 137.5,
    r: 0.5,
    fill: "black",
    fillOpacity: 0.1
  })), _circle149 || (_circle149 = /*#__PURE__*/React.createElement("circle", {
    cx: 131.5,
    cy: 137.5,
    r: 0.5,
    fill: "black",
    fillOpacity: 0.1
  })), _circle150 || (_circle150 = /*#__PURE__*/React.createElement("circle", {
    cx: 140.5,
    cy: 137.5,
    r: 0.5,
    fill: "black",
    fillOpacity: 0.1
  })), _circle151 || (_circle151 = /*#__PURE__*/React.createElement("circle", {
    cx: 149.5,
    cy: 137.5,
    r: 0.5,
    fill: "black",
    fillOpacity: 0.1
  })), _circle152 || (_circle152 = /*#__PURE__*/React.createElement("circle", {
    cx: 158.5,
    cy: 137.5,
    r: 0.5,
    fill: "black",
    fillOpacity: 0.1
  })), _circle153 || (_circle153 = /*#__PURE__*/React.createElement("circle", {
    cx: 167.5,
    cy: 137.5,
    r: 0.5,
    fill: "black",
    fillOpacity: 0.1
  })), _circle154 || (_circle154 = /*#__PURE__*/React.createElement("circle", {
    cx: 176.5,
    cy: 137.5,
    r: 0.5,
    fill: "black",
    fillOpacity: 0.1
  })), _circle155 || (_circle155 = /*#__PURE__*/React.createElement("circle", {
    cx: 185.5,
    cy: 137.5,
    r: 0.5,
    fill: "black",
    fillOpacity: 0.1
  })), _circle156 || (_circle156 = /*#__PURE__*/React.createElement("circle", {
    cx: 194.5,
    cy: 137.5,
    r: 0.5,
    fill: "black",
    fillOpacity: 0.1
  })), _circle157 || (_circle157 = /*#__PURE__*/React.createElement("circle", {
    cx: 203.5,
    cy: 137.5,
    r: 0.5,
    fill: "black",
    fillOpacity: 0.1
  })), _circle158 || (_circle158 = /*#__PURE__*/React.createElement("circle", {
    cx: 212.5,
    cy: 137.5,
    r: 0.5,
    fill: "black",
    fillOpacity: 0.1
  })), _circle159 || (_circle159 = /*#__PURE__*/React.createElement("circle", {
    cx: 68.5,
    cy: 146.5,
    r: 0.5,
    fill: "black",
    fillOpacity: 0.1
  })), _circle160 || (_circle160 = /*#__PURE__*/React.createElement("circle", {
    cx: 77.5,
    cy: 146.5,
    r: 0.5,
    fill: "black",
    fillOpacity: 0.1
  })), _circle161 || (_circle161 = /*#__PURE__*/React.createElement("circle", {
    cx: 86.5,
    cy: 146.5,
    r: 0.5,
    fill: "black",
    fillOpacity: 0.1
  })), _circle162 || (_circle162 = /*#__PURE__*/React.createElement("circle", {
    cx: 95.5,
    cy: 146.5,
    r: 0.5,
    fill: "black",
    fillOpacity: 0.1
  })), _circle163 || (_circle163 = /*#__PURE__*/React.createElement("circle", {
    cx: 104.5,
    cy: 146.5,
    r: 0.5,
    fill: "black",
    fillOpacity: 0.1
  })), _circle164 || (_circle164 = /*#__PURE__*/React.createElement("circle", {
    cx: 113.5,
    cy: 146.5,
    r: 0.5,
    fill: "black",
    fillOpacity: 0.1
  })), _circle165 || (_circle165 = /*#__PURE__*/React.createElement("circle", {
    cx: 122.5,
    cy: 146.5,
    r: 0.5,
    fill: "black",
    fillOpacity: 0.1
  })), _circle166 || (_circle166 = /*#__PURE__*/React.createElement("circle", {
    cx: 131.5,
    cy: 146.5,
    r: 0.5,
    fill: "black",
    fillOpacity: 0.1
  })), _circle167 || (_circle167 = /*#__PURE__*/React.createElement("circle", {
    cx: 140.5,
    cy: 146.5,
    r: 0.5,
    fill: "black",
    fillOpacity: 0.1
  })), _circle168 || (_circle168 = /*#__PURE__*/React.createElement("circle", {
    cx: 149.5,
    cy: 146.5,
    r: 0.5,
    fill: "black",
    fillOpacity: 0.1
  })), _circle169 || (_circle169 = /*#__PURE__*/React.createElement("circle", {
    cx: 158.5,
    cy: 146.5,
    r: 0.5,
    fill: "black",
    fillOpacity: 0.1
  })), _circle170 || (_circle170 = /*#__PURE__*/React.createElement("circle", {
    cx: 167.5,
    cy: 146.5,
    r: 0.5,
    fill: "black",
    fillOpacity: 0.1
  })), _circle171 || (_circle171 = /*#__PURE__*/React.createElement("circle", {
    cx: 176.5,
    cy: 146.5,
    r: 0.5,
    fill: "black",
    fillOpacity: 0.1
  })), _circle172 || (_circle172 = /*#__PURE__*/React.createElement("circle", {
    cx: 185.5,
    cy: 146.5,
    r: 0.5,
    fill: "black",
    fillOpacity: 0.1
  })), _circle173 || (_circle173 = /*#__PURE__*/React.createElement("circle", {
    cx: 194.5,
    cy: 146.5,
    r: 0.5,
    fill: "black",
    fillOpacity: 0.1
  })), _circle174 || (_circle174 = /*#__PURE__*/React.createElement("circle", {
    cx: 203.5,
    cy: 146.5,
    r: 0.5,
    fill: "black",
    fillOpacity: 0.1
  })), _circle175 || (_circle175 = /*#__PURE__*/React.createElement("circle", {
    cx: 212.5,
    cy: 146.5,
    r: 0.5,
    fill: "black",
    fillOpacity: 0.1
  })), _circle176 || (_circle176 = /*#__PURE__*/React.createElement("circle", {
    cx: 68.5,
    cy: 155.5,
    r: 0.5,
    fill: "black",
    fillOpacity: 0.1
  })), _circle177 || (_circle177 = /*#__PURE__*/React.createElement("circle", {
    cx: 77.5,
    cy: 155.5,
    r: 0.5,
    fill: "black",
    fillOpacity: 0.1
  })), _circle178 || (_circle178 = /*#__PURE__*/React.createElement("circle", {
    cx: 86.5,
    cy: 155.5,
    r: 0.5,
    fill: "black",
    fillOpacity: 0.1
  })), _circle179 || (_circle179 = /*#__PURE__*/React.createElement("circle", {
    cx: 95.5,
    cy: 155.5,
    r: 0.5,
    fill: "black",
    fillOpacity: 0.1
  })), _circle180 || (_circle180 = /*#__PURE__*/React.createElement("circle", {
    cx: 104.5,
    cy: 155.5,
    r: 0.5,
    fill: "black",
    fillOpacity: 0.1
  })), _circle181 || (_circle181 = /*#__PURE__*/React.createElement("circle", {
    cx: 113.5,
    cy: 155.5,
    r: 0.5,
    fill: "black",
    fillOpacity: 0.1
  })), _circle182 || (_circle182 = /*#__PURE__*/React.createElement("circle", {
    cx: 122.5,
    cy: 155.5,
    r: 0.5,
    fill: "black",
    fillOpacity: 0.1
  })), _circle183 || (_circle183 = /*#__PURE__*/React.createElement("circle", {
    cx: 131.5,
    cy: 155.5,
    r: 0.5,
    fill: "black",
    fillOpacity: 0.1
  })), _circle184 || (_circle184 = /*#__PURE__*/React.createElement("circle", {
    cx: 140.5,
    cy: 155.5,
    r: 0.5,
    fill: "black",
    fillOpacity: 0.1
  })), _circle185 || (_circle185 = /*#__PURE__*/React.createElement("circle", {
    cx: 149.5,
    cy: 155.5,
    r: 0.5,
    fill: "black",
    fillOpacity: 0.1
  })), _circle186 || (_circle186 = /*#__PURE__*/React.createElement("circle", {
    cx: 158.5,
    cy: 155.5,
    r: 0.5,
    fill: "black",
    fillOpacity: 0.1
  })), _circle187 || (_circle187 = /*#__PURE__*/React.createElement("circle", {
    cx: 167.5,
    cy: 155.5,
    r: 0.5,
    fill: "black",
    fillOpacity: 0.1
  })), _circle188 || (_circle188 = /*#__PURE__*/React.createElement("circle", {
    cx: 176.5,
    cy: 155.5,
    r: 0.5,
    fill: "black",
    fillOpacity: 0.1
  })), _circle189 || (_circle189 = /*#__PURE__*/React.createElement("circle", {
    cx: 185.5,
    cy: 155.5,
    r: 0.5,
    fill: "black",
    fillOpacity: 0.1
  })), _circle190 || (_circle190 = /*#__PURE__*/React.createElement("circle", {
    cx: 194.5,
    cy: 155.5,
    r: 0.5,
    fill: "black",
    fillOpacity: 0.1
  })), _circle191 || (_circle191 = /*#__PURE__*/React.createElement("circle", {
    cx: 203.5,
    cy: 155.5,
    r: 0.5,
    fill: "black",
    fillOpacity: 0.1
  })), _circle192 || (_circle192 = /*#__PURE__*/React.createElement("circle", {
    cx: 212.5,
    cy: 155.5,
    r: 0.5,
    fill: "black",
    fillOpacity: 0.1
  })), _circle193 || (_circle193 = /*#__PURE__*/React.createElement("circle", {
    cx: 68.5,
    cy: 164.5,
    r: 0.5,
    fill: "black",
    fillOpacity: 0.1
  })), _circle194 || (_circle194 = /*#__PURE__*/React.createElement("circle", {
    cx: 77.5,
    cy: 164.5,
    r: 0.5,
    fill: "black",
    fillOpacity: 0.1
  })), _circle195 || (_circle195 = /*#__PURE__*/React.createElement("circle", {
    cx: 86.5,
    cy: 164.5,
    r: 0.5,
    fill: "black",
    fillOpacity: 0.1
  })), _circle196 || (_circle196 = /*#__PURE__*/React.createElement("circle", {
    cx: 95.5,
    cy: 164.5,
    r: 0.5,
    fill: "black",
    fillOpacity: 0.1
  })), _circle197 || (_circle197 = /*#__PURE__*/React.createElement("circle", {
    cx: 104.5,
    cy: 164.5,
    r: 0.5,
    fill: "black",
    fillOpacity: 0.1
  })), _circle198 || (_circle198 = /*#__PURE__*/React.createElement("circle", {
    cx: 113.5,
    cy: 164.5,
    r: 0.5,
    fill: "black",
    fillOpacity: 0.1
  })), _circle199 || (_circle199 = /*#__PURE__*/React.createElement("circle", {
    cx: 122.5,
    cy: 164.5,
    r: 0.5,
    fill: "black",
    fillOpacity: 0.1
  })), _circle200 || (_circle200 = /*#__PURE__*/React.createElement("circle", {
    cx: 131.5,
    cy: 164.5,
    r: 0.5,
    fill: "black",
    fillOpacity: 0.1
  })), _circle201 || (_circle201 = /*#__PURE__*/React.createElement("circle", {
    cx: 140.5,
    cy: 164.5,
    r: 0.5,
    fill: "black",
    fillOpacity: 0.1
  })), _circle202 || (_circle202 = /*#__PURE__*/React.createElement("circle", {
    cx: 149.5,
    cy: 164.5,
    r: 0.5,
    fill: "black",
    fillOpacity: 0.1
  })), _circle203 || (_circle203 = /*#__PURE__*/React.createElement("circle", {
    cx: 158.5,
    cy: 164.5,
    r: 0.5,
    fill: "black",
    fillOpacity: 0.1
  })), _circle204 || (_circle204 = /*#__PURE__*/React.createElement("circle", {
    cx: 167.5,
    cy: 164.5,
    r: 0.5,
    fill: "black",
    fillOpacity: 0.1
  })), _circle205 || (_circle205 = /*#__PURE__*/React.createElement("circle", {
    cx: 176.5,
    cy: 164.5,
    r: 0.5,
    fill: "black",
    fillOpacity: 0.1
  })), _circle206 || (_circle206 = /*#__PURE__*/React.createElement("circle", {
    cx: 185.5,
    cy: 164.5,
    r: 0.5,
    fill: "black",
    fillOpacity: 0.1
  })), _circle207 || (_circle207 = /*#__PURE__*/React.createElement("circle", {
    cx: 194.5,
    cy: 164.5,
    r: 0.5,
    fill: "black",
    fillOpacity: 0.1
  })), _circle208 || (_circle208 = /*#__PURE__*/React.createElement("circle", {
    cx: 203.5,
    cy: 164.5,
    r: 0.5,
    fill: "black",
    fillOpacity: 0.1
  })), _circle209 || (_circle209 = /*#__PURE__*/React.createElement("circle", {
    cx: 212.5,
    cy: 164.5,
    r: 0.5,
    fill: "black",
    fillOpacity: 0.1
  })), _circle210 || (_circle210 = /*#__PURE__*/React.createElement("circle", {
    cx: 68.5,
    cy: 173.5,
    r: 0.5,
    fill: "black",
    fillOpacity: 0.1
  })), _circle211 || (_circle211 = /*#__PURE__*/React.createElement("circle", {
    cx: 77.5,
    cy: 173.5,
    r: 0.5,
    fill: "black",
    fillOpacity: 0.1
  })), _circle212 || (_circle212 = /*#__PURE__*/React.createElement("circle", {
    cx: 86.5,
    cy: 173.5,
    r: 0.5,
    fill: "black",
    fillOpacity: 0.1
  })), _circle213 || (_circle213 = /*#__PURE__*/React.createElement("circle", {
    cx: 95.5,
    cy: 173.5,
    r: 0.5,
    fill: "black",
    fillOpacity: 0.1
  })), _circle214 || (_circle214 = /*#__PURE__*/React.createElement("circle", {
    cx: 104.5,
    cy: 173.5,
    r: 0.5,
    fill: "black",
    fillOpacity: 0.1
  })), _circle215 || (_circle215 = /*#__PURE__*/React.createElement("circle", {
    cx: 113.5,
    cy: 173.5,
    r: 0.5,
    fill: "black",
    fillOpacity: 0.1
  })), _circle216 || (_circle216 = /*#__PURE__*/React.createElement("circle", {
    cx: 122.5,
    cy: 173.5,
    r: 0.5,
    fill: "black",
    fillOpacity: 0.1
  })), _circle217 || (_circle217 = /*#__PURE__*/React.createElement("circle", {
    cx: 131.5,
    cy: 173.5,
    r: 0.5,
    fill: "black",
    fillOpacity: 0.1
  })), _circle218 || (_circle218 = /*#__PURE__*/React.createElement("circle", {
    cx: 140.5,
    cy: 173.5,
    r: 0.5,
    fill: "black",
    fillOpacity: 0.1
  })), _circle219 || (_circle219 = /*#__PURE__*/React.createElement("circle", {
    cx: 149.5,
    cy: 173.5,
    r: 0.5,
    fill: "black",
    fillOpacity: 0.1
  })), _circle220 || (_circle220 = /*#__PURE__*/React.createElement("circle", {
    cx: 158.5,
    cy: 173.5,
    r: 0.5,
    fill: "black",
    fillOpacity: 0.1
  })), _circle221 || (_circle221 = /*#__PURE__*/React.createElement("circle", {
    cx: 167.5,
    cy: 173.5,
    r: 0.5,
    fill: "black",
    fillOpacity: 0.1
  })), _circle222 || (_circle222 = /*#__PURE__*/React.createElement("circle", {
    cx: 176.5,
    cy: 173.5,
    r: 0.5,
    fill: "black",
    fillOpacity: 0.1
  })), _circle223 || (_circle223 = /*#__PURE__*/React.createElement("circle", {
    cx: 185.5,
    cy: 173.5,
    r: 0.5,
    fill: "black",
    fillOpacity: 0.1
  })), _circle224 || (_circle224 = /*#__PURE__*/React.createElement("circle", {
    cx: 194.5,
    cy: 173.5,
    r: 0.5,
    fill: "black",
    fillOpacity: 0.1
  })), _circle225 || (_circle225 = /*#__PURE__*/React.createElement("circle", {
    cx: 203.5,
    cy: 173.5,
    r: 0.5,
    fill: "black",
    fillOpacity: 0.1
  })), _circle226 || (_circle226 = /*#__PURE__*/React.createElement("circle", {
    cx: 212.5,
    cy: 173.5,
    r: 0.5,
    fill: "black",
    fillOpacity: 0.1
  })), _circle227 || (_circle227 = /*#__PURE__*/React.createElement("circle", {
    cx: 68.5,
    cy: 182.5,
    r: 0.5,
    fill: "black",
    fillOpacity: 0.1
  })), _circle228 || (_circle228 = /*#__PURE__*/React.createElement("circle", {
    cx: 77.5,
    cy: 182.5,
    r: 0.5,
    fill: "black",
    fillOpacity: 0.1
  })), _circle229 || (_circle229 = /*#__PURE__*/React.createElement("circle", {
    cx: 86.5,
    cy: 182.5,
    r: 0.5,
    fill: "black",
    fillOpacity: 0.1
  })), _circle230 || (_circle230 = /*#__PURE__*/React.createElement("circle", {
    cx: 95.5,
    cy: 182.5,
    r: 0.5,
    fill: "black",
    fillOpacity: 0.1
  })), _circle231 || (_circle231 = /*#__PURE__*/React.createElement("circle", {
    cx: 104.5,
    cy: 182.5,
    r: 0.5,
    fill: "black",
    fillOpacity: 0.1
  })), _circle232 || (_circle232 = /*#__PURE__*/React.createElement("circle", {
    cx: 113.5,
    cy: 182.5,
    r: 0.5,
    fill: "black",
    fillOpacity: 0.1
  })), _circle233 || (_circle233 = /*#__PURE__*/React.createElement("circle", {
    cx: 122.5,
    cy: 182.5,
    r: 0.5,
    fill: "black",
    fillOpacity: 0.1
  })), _circle234 || (_circle234 = /*#__PURE__*/React.createElement("circle", {
    cx: 131.5,
    cy: 182.5,
    r: 0.5,
    fill: "black",
    fillOpacity: 0.1
  })), _circle235 || (_circle235 = /*#__PURE__*/React.createElement("circle", {
    cx: 140.5,
    cy: 182.5,
    r: 0.5,
    fill: "black",
    fillOpacity: 0.1
  })), _circle236 || (_circle236 = /*#__PURE__*/React.createElement("circle", {
    cx: 149.5,
    cy: 182.5,
    r: 0.5,
    fill: "black",
    fillOpacity: 0.1
  })), _circle237 || (_circle237 = /*#__PURE__*/React.createElement("circle", {
    cx: 158.5,
    cy: 182.5,
    r: 0.5,
    fill: "black",
    fillOpacity: 0.1
  })), _circle238 || (_circle238 = /*#__PURE__*/React.createElement("circle", {
    cx: 167.5,
    cy: 182.5,
    r: 0.5,
    fill: "black",
    fillOpacity: 0.1
  })), _circle239 || (_circle239 = /*#__PURE__*/React.createElement("circle", {
    cx: 176.5,
    cy: 182.5,
    r: 0.5,
    fill: "black",
    fillOpacity: 0.1
  })), _circle240 || (_circle240 = /*#__PURE__*/React.createElement("circle", {
    cx: 185.5,
    cy: 182.5,
    r: 0.5,
    fill: "black",
    fillOpacity: 0.1
  })), _circle241 || (_circle241 = /*#__PURE__*/React.createElement("circle", {
    cx: 194.5,
    cy: 182.5,
    r: 0.5,
    fill: "black",
    fillOpacity: 0.1
  })), _circle242 || (_circle242 = /*#__PURE__*/React.createElement("circle", {
    cx: 203.5,
    cy: 182.5,
    r: 0.5,
    fill: "black",
    fillOpacity: 0.1
  })), _circle243 || (_circle243 = /*#__PURE__*/React.createElement("circle", {
    cx: 212.5,
    cy: 182.5,
    r: 0.5,
    fill: "black",
    fillOpacity: 0.1
  })), _circle244 || (_circle244 = /*#__PURE__*/React.createElement("circle", {
    cx: 68.5,
    cy: 191.5,
    r: 0.5,
    fill: "black",
    fillOpacity: 0.1
  })), _circle245 || (_circle245 = /*#__PURE__*/React.createElement("circle", {
    cx: 77.5,
    cy: 191.5,
    r: 0.5,
    fill: "black",
    fillOpacity: 0.1
  })), _circle246 || (_circle246 = /*#__PURE__*/React.createElement("circle", {
    cx: 86.5,
    cy: 191.5,
    r: 0.5,
    fill: "black",
    fillOpacity: 0.1
  })), _circle247 || (_circle247 = /*#__PURE__*/React.createElement("circle", {
    cx: 95.5,
    cy: 191.5,
    r: 0.5,
    fill: "black",
    fillOpacity: 0.1
  })), _circle248 || (_circle248 = /*#__PURE__*/React.createElement("circle", {
    cx: 104.5,
    cy: 191.5,
    r: 0.5,
    fill: "black",
    fillOpacity: 0.1
  })), _circle249 || (_circle249 = /*#__PURE__*/React.createElement("circle", {
    cx: 113.5,
    cy: 191.5,
    r: 0.5,
    fill: "black",
    fillOpacity: 0.1
  })), _circle250 || (_circle250 = /*#__PURE__*/React.createElement("circle", {
    cx: 122.5,
    cy: 191.5,
    r: 0.5,
    fill: "black",
    fillOpacity: 0.1
  })), _circle251 || (_circle251 = /*#__PURE__*/React.createElement("circle", {
    cx: 131.5,
    cy: 191.5,
    r: 0.5,
    fill: "black",
    fillOpacity: 0.1
  })), _circle252 || (_circle252 = /*#__PURE__*/React.createElement("circle", {
    cx: 140.5,
    cy: 191.5,
    r: 0.5,
    fill: "black",
    fillOpacity: 0.1
  })), _circle253 || (_circle253 = /*#__PURE__*/React.createElement("circle", {
    cx: 149.5,
    cy: 191.5,
    r: 0.5,
    fill: "black",
    fillOpacity: 0.1
  })), _circle254 || (_circle254 = /*#__PURE__*/React.createElement("circle", {
    cx: 158.5,
    cy: 191.5,
    r: 0.5,
    fill: "black",
    fillOpacity: 0.1
  })), _circle255 || (_circle255 = /*#__PURE__*/React.createElement("circle", {
    cx: 167.5,
    cy: 191.5,
    r: 0.5,
    fill: "black",
    fillOpacity: 0.1
  })), _circle256 || (_circle256 = /*#__PURE__*/React.createElement("circle", {
    cx: 176.5,
    cy: 191.5,
    r: 0.5,
    fill: "black",
    fillOpacity: 0.1
  })), _circle257 || (_circle257 = /*#__PURE__*/React.createElement("circle", {
    cx: 185.5,
    cy: 191.5,
    r: 0.5,
    fill: "black",
    fillOpacity: 0.1
  })), _circle258 || (_circle258 = /*#__PURE__*/React.createElement("circle", {
    cx: 194.5,
    cy: 191.5,
    r: 0.5,
    fill: "black",
    fillOpacity: 0.1
  })), _circle259 || (_circle259 = /*#__PURE__*/React.createElement("circle", {
    cx: 203.5,
    cy: 191.5,
    r: 0.5,
    fill: "black",
    fillOpacity: 0.1
  })), _circle260 || (_circle260 = /*#__PURE__*/React.createElement("circle", {
    cx: 212.5,
    cy: 191.5,
    r: 0.5,
    fill: "black",
    fillOpacity: 0.1
  })), _circle261 || (_circle261 = /*#__PURE__*/React.createElement("circle", {
    cx: 68.5,
    cy: 200.5,
    r: 0.5,
    fill: "black",
    fillOpacity: 0.1
  })), _circle262 || (_circle262 = /*#__PURE__*/React.createElement("circle", {
    cx: 77.5,
    cy: 200.5,
    r: 0.5,
    fill: "black",
    fillOpacity: 0.1
  })), _circle263 || (_circle263 = /*#__PURE__*/React.createElement("circle", {
    cx: 86.5,
    cy: 200.5,
    r: 0.5,
    fill: "black",
    fillOpacity: 0.1
  })), _circle264 || (_circle264 = /*#__PURE__*/React.createElement("circle", {
    cx: 95.5,
    cy: 200.5,
    r: 0.5,
    fill: "black",
    fillOpacity: 0.1
  })), _circle265 || (_circle265 = /*#__PURE__*/React.createElement("circle", {
    cx: 104.5,
    cy: 200.5,
    r: 0.5,
    fill: "black",
    fillOpacity: 0.1
  })), _circle266 || (_circle266 = /*#__PURE__*/React.createElement("circle", {
    cx: 113.5,
    cy: 200.5,
    r: 0.5,
    fill: "black",
    fillOpacity: 0.1
  })), _circle267 || (_circle267 = /*#__PURE__*/React.createElement("circle", {
    cx: 122.5,
    cy: 200.5,
    r: 0.5,
    fill: "black",
    fillOpacity: 0.1
  })), _circle268 || (_circle268 = /*#__PURE__*/React.createElement("circle", {
    cx: 131.5,
    cy: 200.5,
    r: 0.5,
    fill: "black",
    fillOpacity: 0.1
  })), _circle269 || (_circle269 = /*#__PURE__*/React.createElement("circle", {
    cx: 140.5,
    cy: 200.5,
    r: 0.5,
    fill: "black",
    fillOpacity: 0.1
  })), _circle270 || (_circle270 = /*#__PURE__*/React.createElement("circle", {
    cx: 149.5,
    cy: 200.5,
    r: 0.5,
    fill: "black",
    fillOpacity: 0.1
  })), _circle271 || (_circle271 = /*#__PURE__*/React.createElement("circle", {
    cx: 158.5,
    cy: 200.5,
    r: 0.5,
    fill: "black",
    fillOpacity: 0.1
  })), _circle272 || (_circle272 = /*#__PURE__*/React.createElement("circle", {
    cx: 167.5,
    cy: 200.5,
    r: 0.5,
    fill: "black",
    fillOpacity: 0.1
  })), _circle273 || (_circle273 = /*#__PURE__*/React.createElement("circle", {
    cx: 176.5,
    cy: 200.5,
    r: 0.5,
    fill: "black",
    fillOpacity: 0.1
  })), _circle274 || (_circle274 = /*#__PURE__*/React.createElement("circle", {
    cx: 185.5,
    cy: 200.5,
    r: 0.5,
    fill: "black",
    fillOpacity: 0.1
  })), _circle275 || (_circle275 = /*#__PURE__*/React.createElement("circle", {
    cx: 194.5,
    cy: 200.5,
    r: 0.5,
    fill: "black",
    fillOpacity: 0.1
  })), _circle276 || (_circle276 = /*#__PURE__*/React.createElement("circle", {
    cx: 203.5,
    cy: 200.5,
    r: 0.5,
    fill: "black",
    fillOpacity: 0.1
  })), _circle277 || (_circle277 = /*#__PURE__*/React.createElement("circle", {
    cx: 212.5,
    cy: 200.5,
    r: 0.5,
    fill: "black",
    fillOpacity: 0.1
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 55,
    y: 43,
    width: 170,
    height: 172,
    rx: 14,
    fill: "url(#paint1_linear_1_999)"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 55,
    y: 32,
    width: 2,
    height: 6,
    rx: 1,
    fill: "#F9CB2F",
    fillOpacity: 0.5
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 61,
    y: 32,
    width: 2,
    height: 6,
    rx: 1,
    fill: "#F9CB2F",
    fillOpacity: 0.5
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 67,
    y: 32,
    width: 2,
    height: 6,
    rx: 1,
    fill: "#F9CB2F",
    fillOpacity: 0.5
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 73,
    y: 32,
    width: 2,
    height: 6,
    rx: 1,
    fill: "#F9CB2F",
    fillOpacity: 0.5
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 79,
    y: 32,
    width: 2,
    height: 6,
    rx: 1,
    fill: "#F9CB2F",
    fillOpacity: 0.5
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 85,
    y: 32,
    width: 2,
    height: 6,
    rx: 1,
    fill: "#F9CB2F",
    fillOpacity: 0.5
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 91,
    y: 32,
    width: 2,
    height: 6,
    rx: 1,
    fill: "#F9CB2F",
    fillOpacity: 0.5
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 97,
    y: 32,
    width: 2,
    height: 6,
    rx: 1,
    fill: "#F9CB2F",
    fillOpacity: 0.5
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 103,
    y: 32,
    width: 2,
    height: 6,
    rx: 1,
    fill: "#F9CB2F",
    fillOpacity: 0.5
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 109,
    y: 32,
    width: 2,
    height: 6,
    rx: 1,
    fill: "#F9CB2F",
    fillOpacity: 0.5
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 115,
    y: 32,
    width: 2,
    height: 6,
    rx: 1,
    fill: "#F9CB2F",
    fillOpacity: 0.5
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 121,
    y: 32,
    width: 2,
    height: 6,
    rx: 1,
    fill: "#F9CB2F",
    fillOpacity: 0.5
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 127,
    y: 32,
    width: 2,
    height: 6,
    rx: 1,
    fill: "#F9CB2F",
    fillOpacity: 0.5
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    x: 133,
    y: 32,
    width: 2,
    height: 6,
    rx: 1,
    fill: "#F9CB2F",
    fillOpacity: 0.5
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    x: 139,
    y: 32,
    width: 2,
    height: 6,
    rx: 1,
    fill: "#F9CB2F",
    fillOpacity: 0.5
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    x: 145,
    y: 32,
    width: 2,
    height: 6,
    rx: 1,
    fill: "#F9CB2F",
    fillOpacity: 0.5
  })), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    x: 151,
    y: 32,
    width: 2,
    height: 6,
    rx: 1,
    fill: "#F9CB2F",
    fillOpacity: 0.5
  })), _rect21 || (_rect21 = /*#__PURE__*/React.createElement("rect", {
    x: 157,
    y: 32,
    width: 2,
    height: 6,
    rx: 1,
    fill: "#F9CB2F",
    fillOpacity: 0.5
  })), _rect22 || (_rect22 = /*#__PURE__*/React.createElement("rect", {
    x: 163,
    y: 32,
    width: 2,
    height: 6,
    rx: 1,
    fill: "#F9CB2F",
    fillOpacity: 0.5
  })), _rect23 || (_rect23 = /*#__PURE__*/React.createElement("rect", {
    x: 169,
    y: 32,
    width: 2,
    height: 6,
    rx: 1,
    fill: "#F9CB2F",
    fillOpacity: 0.5
  })), _rect24 || (_rect24 = /*#__PURE__*/React.createElement("rect", {
    x: 175,
    y: 32,
    width: 2,
    height: 6,
    rx: 1,
    fill: "#F9CB2F",
    fillOpacity: 0.5
  })), _rect25 || (_rect25 = /*#__PURE__*/React.createElement("rect", {
    x: 181,
    y: 32,
    width: 2,
    height: 6,
    rx: 1,
    fill: "#F9CB2F",
    fillOpacity: 0.5
  })), _rect26 || (_rect26 = /*#__PURE__*/React.createElement("rect", {
    x: 187,
    y: 32,
    width: 2,
    height: 6,
    rx: 1,
    fill: "#F9CB2F",
    fillOpacity: 0.5
  })), _rect27 || (_rect27 = /*#__PURE__*/React.createElement("rect", {
    x: 193,
    y: 32,
    width: 2,
    height: 6,
    rx: 1,
    fill: "#F9CB2F",
    fillOpacity: 0.5
  })), _rect28 || (_rect28 = /*#__PURE__*/React.createElement("rect", {
    x: 199,
    y: 32,
    width: 2,
    height: 6,
    rx: 1,
    fill: "#F9CB2F",
    fillOpacity: 0.5
  })), _rect29 || (_rect29 = /*#__PURE__*/React.createElement("rect", {
    x: 205,
    y: 32,
    width: 2,
    height: 6,
    rx: 1,
    fill: "#F9CB2F",
    fillOpacity: 0.5
  })), _rect30 || (_rect30 = /*#__PURE__*/React.createElement("rect", {
    x: 211,
    y: 32,
    width: 2,
    height: 6,
    rx: 1,
    fill: "#F9CB2F",
    fillOpacity: 0.5
  })), _rect31 || (_rect31 = /*#__PURE__*/React.createElement("rect", {
    x: 217,
    y: 32,
    width: 2,
    height: 6,
    rx: 1,
    fill: "#F9CB2F",
    fillOpacity: 0.5
  })), _rect32 || (_rect32 = /*#__PURE__*/React.createElement("rect", {
    x: 223,
    y: 32,
    width: 2,
    height: 6,
    rx: 1,
    fill: "#F9CB2F",
    fillOpacity: 0.5
  })), _rect33 || (_rect33 = /*#__PURE__*/React.createElement("rect", {
    x: 55,
    y: 218,
    width: 2,
    height: 6,
    rx: 1,
    fill: "#F9CB2F",
    fillOpacity: 0.5
  })), _rect34 || (_rect34 = /*#__PURE__*/React.createElement("rect", {
    x: 61,
    y: 218,
    width: 2,
    height: 6,
    rx: 1,
    fill: "#F9CB2F",
    fillOpacity: 0.5
  })), _rect35 || (_rect35 = /*#__PURE__*/React.createElement("rect", {
    x: 67,
    y: 218,
    width: 2,
    height: 6,
    rx: 1,
    fill: "#F9CB2F",
    fillOpacity: 0.5
  })), _rect36 || (_rect36 = /*#__PURE__*/React.createElement("rect", {
    x: 73,
    y: 218,
    width: 2,
    height: 6,
    rx: 1,
    fill: "#F9CB2F",
    fillOpacity: 0.5
  })), _rect37 || (_rect37 = /*#__PURE__*/React.createElement("rect", {
    x: 79,
    y: 218,
    width: 2,
    height: 6,
    rx: 1,
    fill: "#F9CB2F",
    fillOpacity: 0.5
  })), _rect38 || (_rect38 = /*#__PURE__*/React.createElement("rect", {
    x: 85,
    y: 218,
    width: 2,
    height: 6,
    rx: 1,
    fill: "#F9CB2F",
    fillOpacity: 0.5
  })), _rect39 || (_rect39 = /*#__PURE__*/React.createElement("rect", {
    x: 91,
    y: 218,
    width: 2,
    height: 6,
    rx: 1,
    fill: "#F9CB2F",
    fillOpacity: 0.5
  })), _rect40 || (_rect40 = /*#__PURE__*/React.createElement("rect", {
    x: 97,
    y: 218,
    width: 2,
    height: 6,
    rx: 1,
    fill: "#F9CB2F",
    fillOpacity: 0.5
  })), _rect41 || (_rect41 = /*#__PURE__*/React.createElement("rect", {
    x: 103,
    y: 218,
    width: 2,
    height: 6,
    rx: 1,
    fill: "#F9CB2F",
    fillOpacity: 0.5
  })), _rect42 || (_rect42 = /*#__PURE__*/React.createElement("rect", {
    x: 109,
    y: 218,
    width: 2,
    height: 6,
    rx: 1,
    fill: "#F9CB2F",
    fillOpacity: 0.5
  })), _rect43 || (_rect43 = /*#__PURE__*/React.createElement("rect", {
    x: 115,
    y: 218,
    width: 2,
    height: 6,
    rx: 1,
    fill: "#F9CB2F",
    fillOpacity: 0.5
  })), _rect44 || (_rect44 = /*#__PURE__*/React.createElement("rect", {
    x: 121,
    y: 218,
    width: 2,
    height: 6,
    rx: 1,
    fill: "#F9CB2F",
    fillOpacity: 0.5
  })), _rect45 || (_rect45 = /*#__PURE__*/React.createElement("rect", {
    x: 127,
    y: 218,
    width: 2,
    height: 6,
    rx: 1,
    fill: "#F9CB2F",
    fillOpacity: 0.5
  })), _rect46 || (_rect46 = /*#__PURE__*/React.createElement("rect", {
    x: 133,
    y: 218,
    width: 2,
    height: 6,
    rx: 1,
    fill: "#F9CB2F",
    fillOpacity: 0.5
  })), _rect47 || (_rect47 = /*#__PURE__*/React.createElement("rect", {
    x: 139,
    y: 218,
    width: 2,
    height: 6,
    rx: 1,
    fill: "#F9CB2F",
    fillOpacity: 0.5
  })), _rect48 || (_rect48 = /*#__PURE__*/React.createElement("rect", {
    x: 145,
    y: 218,
    width: 2,
    height: 6,
    rx: 1,
    fill: "#F9CB2F",
    fillOpacity: 0.5
  })), _rect49 || (_rect49 = /*#__PURE__*/React.createElement("rect", {
    x: 151,
    y: 218,
    width: 2,
    height: 6,
    rx: 1,
    fill: "#F9CB2F",
    fillOpacity: 0.5
  })), _rect50 || (_rect50 = /*#__PURE__*/React.createElement("rect", {
    x: 157,
    y: 218,
    width: 2,
    height: 6,
    rx: 1,
    fill: "#F9CB2F",
    fillOpacity: 0.5
  })), _rect51 || (_rect51 = /*#__PURE__*/React.createElement("rect", {
    x: 163,
    y: 218,
    width: 2,
    height: 6,
    rx: 1,
    fill: "#F9CB2F",
    fillOpacity: 0.5
  })), _rect52 || (_rect52 = /*#__PURE__*/React.createElement("rect", {
    x: 169,
    y: 218,
    width: 2,
    height: 6,
    rx: 1,
    fill: "#F9CB2F",
    fillOpacity: 0.5
  })), _rect53 || (_rect53 = /*#__PURE__*/React.createElement("rect", {
    x: 175,
    y: 218,
    width: 2,
    height: 6,
    rx: 1,
    fill: "#F9CB2F",
    fillOpacity: 0.5
  })), _rect54 || (_rect54 = /*#__PURE__*/React.createElement("rect", {
    x: 181,
    y: 218,
    width: 2,
    height: 6,
    rx: 1,
    fill: "#F9CB2F",
    fillOpacity: 0.5
  })), _rect55 || (_rect55 = /*#__PURE__*/React.createElement("rect", {
    x: 187,
    y: 218,
    width: 2,
    height: 6,
    rx: 1,
    fill: "#F9CB2F",
    fillOpacity: 0.5
  })), _rect56 || (_rect56 = /*#__PURE__*/React.createElement("rect", {
    x: 193,
    y: 218,
    width: 2,
    height: 6,
    rx: 1,
    fill: "#F9CB2F",
    fillOpacity: 0.5
  })), _rect57 || (_rect57 = /*#__PURE__*/React.createElement("rect", {
    x: 199,
    y: 218,
    width: 2,
    height: 6,
    rx: 1,
    fill: "#F9CB2F",
    fillOpacity: 0.5
  })), _rect58 || (_rect58 = /*#__PURE__*/React.createElement("rect", {
    x: 205,
    y: 218,
    width: 2,
    height: 6,
    rx: 1,
    fill: "#F9CB2F",
    fillOpacity: 0.5
  })), _rect59 || (_rect59 = /*#__PURE__*/React.createElement("rect", {
    x: 211,
    y: 218,
    width: 2,
    height: 6,
    rx: 1,
    fill: "#F9CB2F",
    fillOpacity: 0.5
  })), _rect60 || (_rect60 = /*#__PURE__*/React.createElement("rect", {
    x: 217,
    y: 218,
    width: 2,
    height: 6,
    rx: 1,
    fill: "#F9CB2F",
    fillOpacity: 0.5
  })), _rect61 || (_rect61 = /*#__PURE__*/React.createElement("rect", {
    x: 223,
    y: 218,
    width: 2,
    height: 6,
    rx: 1,
    fill: "#F9CB2F",
    fillOpacity: 0.5
  })), _rect62 || (_rect62 = /*#__PURE__*/React.createElement("rect", {
    x: 44,
    y: 213,
    width: 2,
    height: 6,
    rx: 1,
    transform: "rotate(-90 44 213)",
    fill: "#F9CB2F",
    fillOpacity: 0.5
  })), _rect63 || (_rect63 = /*#__PURE__*/React.createElement("rect", {
    x: 44,
    y: 207,
    width: 2,
    height: 6,
    rx: 1,
    transform: "rotate(-90 44 207)",
    fill: "#F9CB2F",
    fillOpacity: 0.5
  })), _rect64 || (_rect64 = /*#__PURE__*/React.createElement("rect", {
    x: 44,
    y: 201,
    width: 2,
    height: 6,
    rx: 1,
    transform: "rotate(-90 44 201)",
    fill: "#F9CB2F",
    fillOpacity: 0.5
  })), _rect65 || (_rect65 = /*#__PURE__*/React.createElement("rect", {
    x: 44,
    y: 195,
    width: 2,
    height: 6,
    rx: 1,
    transform: "rotate(-90 44 195)",
    fill: "#F9CB2F",
    fillOpacity: 0.5
  })), _rect66 || (_rect66 = /*#__PURE__*/React.createElement("rect", {
    x: 44,
    y: 189,
    width: 2,
    height: 6,
    rx: 1,
    transform: "rotate(-90 44 189)",
    fill: "#F9CB2F",
    fillOpacity: 0.5
  })), _rect67 || (_rect67 = /*#__PURE__*/React.createElement("rect", {
    x: 44,
    y: 183,
    width: 2,
    height: 6,
    rx: 1,
    transform: "rotate(-90 44 183)",
    fill: "#F9CB2F",
    fillOpacity: 0.5
  })), _rect68 || (_rect68 = /*#__PURE__*/React.createElement("rect", {
    x: 44,
    y: 177,
    width: 2,
    height: 6,
    rx: 1,
    transform: "rotate(-90 44 177)",
    fill: "#F9CB2F",
    fillOpacity: 0.5
  })), _rect69 || (_rect69 = /*#__PURE__*/React.createElement("rect", {
    x: 44,
    y: 171,
    width: 2,
    height: 6,
    rx: 1,
    transform: "rotate(-90 44 171)",
    fill: "#F9CB2F",
    fillOpacity: 0.5
  })), _rect70 || (_rect70 = /*#__PURE__*/React.createElement("rect", {
    x: 44,
    y: 165,
    width: 2,
    height: 6,
    rx: 1,
    transform: "rotate(-90 44 165)",
    fill: "#F9CB2F",
    fillOpacity: 0.5
  })), _rect71 || (_rect71 = /*#__PURE__*/React.createElement("rect", {
    x: 44,
    y: 159,
    width: 2,
    height: 6,
    rx: 1,
    transform: "rotate(-90 44 159)",
    fill: "#F9CB2F",
    fillOpacity: 0.5
  })), _rect72 || (_rect72 = /*#__PURE__*/React.createElement("rect", {
    x: 44,
    y: 153,
    width: 2,
    height: 6,
    rx: 1,
    transform: "rotate(-90 44 153)",
    fill: "#F9CB2F",
    fillOpacity: 0.5
  })), _rect73 || (_rect73 = /*#__PURE__*/React.createElement("rect", {
    x: 44,
    y: 147,
    width: 2,
    height: 6,
    rx: 1,
    transform: "rotate(-90 44 147)",
    fill: "#F9CB2F",
    fillOpacity: 0.5
  })), _rect74 || (_rect74 = /*#__PURE__*/React.createElement("rect", {
    x: 44,
    y: 141,
    width: 2,
    height: 6,
    rx: 1,
    transform: "rotate(-90 44 141)",
    fill: "#F9CB2F",
    fillOpacity: 0.5
  })), _rect75 || (_rect75 = /*#__PURE__*/React.createElement("rect", {
    x: 44,
    y: 135,
    width: 2,
    height: 6,
    rx: 1,
    transform: "rotate(-90 44 135)",
    fill: "#F9CB2F",
    fillOpacity: 0.5
  })), _rect76 || (_rect76 = /*#__PURE__*/React.createElement("rect", {
    x: 44,
    y: 129,
    width: 2,
    height: 6,
    rx: 1,
    transform: "rotate(-90 44 129)",
    fill: "#F9CB2F",
    fillOpacity: 0.5
  })), _rect77 || (_rect77 = /*#__PURE__*/React.createElement("rect", {
    x: 44,
    y: 123,
    width: 2,
    height: 6,
    rx: 1,
    transform: "rotate(-90 44 123)",
    fill: "#F9CB2F",
    fillOpacity: 0.5
  })), _rect78 || (_rect78 = /*#__PURE__*/React.createElement("rect", {
    x: 44,
    y: 117,
    width: 2,
    height: 6,
    rx: 1,
    transform: "rotate(-90 44 117)",
    fill: "#F9CB2F",
    fillOpacity: 0.5
  })), _rect79 || (_rect79 = /*#__PURE__*/React.createElement("rect", {
    x: 44,
    y: 111,
    width: 2,
    height: 6,
    rx: 1,
    transform: "rotate(-90 44 111)",
    fill: "#F9CB2F",
    fillOpacity: 0.5
  })), _rect80 || (_rect80 = /*#__PURE__*/React.createElement("rect", {
    x: 44,
    y: 105,
    width: 2,
    height: 6,
    rx: 1,
    transform: "rotate(-90 44 105)",
    fill: "#F9CB2F",
    fillOpacity: 0.5
  })), _rect81 || (_rect81 = /*#__PURE__*/React.createElement("rect", {
    x: 44,
    y: 99,
    width: 2,
    height: 6,
    rx: 1,
    transform: "rotate(-90 44 99)",
    fill: "#F9CB2F",
    fillOpacity: 0.5
  })), _rect82 || (_rect82 = /*#__PURE__*/React.createElement("rect", {
    x: 44,
    y: 93,
    width: 2,
    height: 6,
    rx: 1,
    transform: "rotate(-90 44 93)",
    fill: "#F9CB2F",
    fillOpacity: 0.5
  })), _rect83 || (_rect83 = /*#__PURE__*/React.createElement("rect", {
    x: 44,
    y: 87,
    width: 2,
    height: 6,
    rx: 1,
    transform: "rotate(-90 44 87)",
    fill: "#F9CB2F",
    fillOpacity: 0.5
  })), _rect84 || (_rect84 = /*#__PURE__*/React.createElement("rect", {
    x: 44,
    y: 81,
    width: 2,
    height: 6,
    rx: 1,
    transform: "rotate(-90 44 81)",
    fill: "#F9CB2F",
    fillOpacity: 0.5
  })), _rect85 || (_rect85 = /*#__PURE__*/React.createElement("rect", {
    x: 44,
    y: 75,
    width: 2,
    height: 6,
    rx: 1,
    transform: "rotate(-90 44 75)",
    fill: "#F9CB2F",
    fillOpacity: 0.5
  })), _rect86 || (_rect86 = /*#__PURE__*/React.createElement("rect", {
    x: 44,
    y: 69,
    width: 2,
    height: 6,
    rx: 1,
    transform: "rotate(-90 44 69)",
    fill: "#F9CB2F",
    fillOpacity: 0.5
  })), _rect87 || (_rect87 = /*#__PURE__*/React.createElement("rect", {
    x: 44,
    y: 63,
    width: 2,
    height: 6,
    rx: 1,
    transform: "rotate(-90 44 63)",
    fill: "#F9CB2F",
    fillOpacity: 0.5
  })), _rect88 || (_rect88 = /*#__PURE__*/React.createElement("rect", {
    x: 44,
    y: 57,
    width: 2,
    height: 6,
    rx: 1,
    transform: "rotate(-90 44 57)",
    fill: "#F9CB2F",
    fillOpacity: 0.5
  })), _rect89 || (_rect89 = /*#__PURE__*/React.createElement("rect", {
    x: 44,
    y: 51,
    width: 2,
    height: 6,
    rx: 1,
    transform: "rotate(-90 44 51)",
    fill: "#F9CB2F",
    fillOpacity: 0.5
  })), _rect90 || (_rect90 = /*#__PURE__*/React.createElement("rect", {
    x: 44,
    y: 45,
    width: 2,
    height: 6,
    rx: 1,
    transform: "rotate(-90 44 45)",
    fill: "#F9CB2F",
    fillOpacity: 0.5
  })), _rect91 || (_rect91 = /*#__PURE__*/React.createElement("rect", {
    x: 230,
    y: 213,
    width: 2,
    height: 6,
    rx: 1,
    transform: "rotate(-90 230 213)",
    fill: "#F9CB2F",
    fillOpacity: 0.5
  })), _rect92 || (_rect92 = /*#__PURE__*/React.createElement("rect", {
    x: 230,
    y: 207,
    width: 2,
    height: 6,
    rx: 1,
    transform: "rotate(-90 230 207)",
    fill: "#F9CB2F",
    fillOpacity: 0.5
  })), _rect93 || (_rect93 = /*#__PURE__*/React.createElement("rect", {
    x: 230,
    y: 201,
    width: 2,
    height: 6,
    rx: 1,
    transform: "rotate(-90 230 201)",
    fill: "#F9CB2F",
    fillOpacity: 0.5
  })), _rect94 || (_rect94 = /*#__PURE__*/React.createElement("rect", {
    x: 230,
    y: 195,
    width: 2,
    height: 6,
    rx: 1,
    transform: "rotate(-90 230 195)",
    fill: "#F9CB2F",
    fillOpacity: 0.5
  })), _rect95 || (_rect95 = /*#__PURE__*/React.createElement("rect", {
    x: 230,
    y: 189,
    width: 2,
    height: 6,
    rx: 1,
    transform: "rotate(-90 230 189)",
    fill: "#F9CB2F",
    fillOpacity: 0.5
  })), _rect96 || (_rect96 = /*#__PURE__*/React.createElement("rect", {
    x: 230,
    y: 183,
    width: 2,
    height: 6,
    rx: 1,
    transform: "rotate(-90 230 183)",
    fill: "#F9CB2F",
    fillOpacity: 0.5
  })), _rect97 || (_rect97 = /*#__PURE__*/React.createElement("rect", {
    x: 230,
    y: 177,
    width: 2,
    height: 6,
    rx: 1,
    transform: "rotate(-90 230 177)",
    fill: "#F9CB2F",
    fillOpacity: 0.5
  })), _rect98 || (_rect98 = /*#__PURE__*/React.createElement("rect", {
    x: 230,
    y: 171,
    width: 2,
    height: 6,
    rx: 1,
    transform: "rotate(-90 230 171)",
    fill: "#F9CB2F",
    fillOpacity: 0.5
  })), _rect99 || (_rect99 = /*#__PURE__*/React.createElement("rect", {
    x: 230,
    y: 165,
    width: 2,
    height: 6,
    rx: 1,
    transform: "rotate(-90 230 165)",
    fill: "#F9CB2F",
    fillOpacity: 0.5
  })), _rect100 || (_rect100 = /*#__PURE__*/React.createElement("rect", {
    x: 230,
    y: 159,
    width: 2,
    height: 6,
    rx: 1,
    transform: "rotate(-90 230 159)",
    fill: "#F9CB2F",
    fillOpacity: 0.5
  })), _rect101 || (_rect101 = /*#__PURE__*/React.createElement("rect", {
    x: 230,
    y: 153,
    width: 2,
    height: 6,
    rx: 1,
    transform: "rotate(-90 230 153)",
    fill: "#F9CB2F",
    fillOpacity: 0.5
  })), _rect102 || (_rect102 = /*#__PURE__*/React.createElement("rect", {
    x: 230,
    y: 147,
    width: 2,
    height: 6,
    rx: 1,
    transform: "rotate(-90 230 147)",
    fill: "#F9CB2F",
    fillOpacity: 0.5
  })), _rect103 || (_rect103 = /*#__PURE__*/React.createElement("rect", {
    x: 230,
    y: 141,
    width: 2,
    height: 6,
    rx: 1,
    transform: "rotate(-90 230 141)",
    fill: "#F9CB2F",
    fillOpacity: 0.5
  })), _rect104 || (_rect104 = /*#__PURE__*/React.createElement("rect", {
    x: 230,
    y: 135,
    width: 2,
    height: 6,
    rx: 1,
    transform: "rotate(-90 230 135)",
    fill: "#F9CB2F",
    fillOpacity: 0.5
  })), _rect105 || (_rect105 = /*#__PURE__*/React.createElement("rect", {
    x: 230,
    y: 129,
    width: 2,
    height: 6,
    rx: 1,
    transform: "rotate(-90 230 129)",
    fill: "#F9CB2F",
    fillOpacity: 0.5
  })), _rect106 || (_rect106 = /*#__PURE__*/React.createElement("rect", {
    x: 230,
    y: 123,
    width: 2,
    height: 6,
    rx: 1,
    transform: "rotate(-90 230 123)",
    fill: "#F9CB2F",
    fillOpacity: 0.5
  })), _rect107 || (_rect107 = /*#__PURE__*/React.createElement("rect", {
    x: 230,
    y: 117,
    width: 2,
    height: 6,
    rx: 1,
    transform: "rotate(-90 230 117)",
    fill: "#F9CB2F",
    fillOpacity: 0.5
  })), _rect108 || (_rect108 = /*#__PURE__*/React.createElement("rect", {
    x: 230,
    y: 111,
    width: 2,
    height: 6,
    rx: 1,
    transform: "rotate(-90 230 111)",
    fill: "#F9CB2F",
    fillOpacity: 0.5
  })), _rect109 || (_rect109 = /*#__PURE__*/React.createElement("rect", {
    x: 230,
    y: 105,
    width: 2,
    height: 6,
    rx: 1,
    transform: "rotate(-90 230 105)",
    fill: "#F9CB2F",
    fillOpacity: 0.5
  })), _rect110 || (_rect110 = /*#__PURE__*/React.createElement("rect", {
    x: 230,
    y: 99,
    width: 2,
    height: 6,
    rx: 1,
    transform: "rotate(-90 230 99)",
    fill: "#F9CB2F",
    fillOpacity: 0.5
  })), _rect111 || (_rect111 = /*#__PURE__*/React.createElement("rect", {
    x: 230,
    y: 93,
    width: 2,
    height: 6,
    rx: 1,
    transform: "rotate(-90 230 93)",
    fill: "#F9CB2F",
    fillOpacity: 0.5
  })), _rect112 || (_rect112 = /*#__PURE__*/React.createElement("rect", {
    x: 230,
    y: 87,
    width: 2,
    height: 6,
    rx: 1,
    transform: "rotate(-90 230 87)",
    fill: "#F9CB2F",
    fillOpacity: 0.5
  })), _rect113 || (_rect113 = /*#__PURE__*/React.createElement("rect", {
    x: 230,
    y: 81,
    width: 2,
    height: 6,
    rx: 1,
    transform: "rotate(-90 230 81)",
    fill: "#F9CB2F",
    fillOpacity: 0.5
  })), _rect114 || (_rect114 = /*#__PURE__*/React.createElement("rect", {
    x: 230,
    y: 75,
    width: 2,
    height: 6,
    rx: 1,
    transform: "rotate(-90 230 75)",
    fill: "#F9CB2F",
    fillOpacity: 0.5
  })), _rect115 || (_rect115 = /*#__PURE__*/React.createElement("rect", {
    x: 230,
    y: 69,
    width: 2,
    height: 6,
    rx: 1,
    transform: "rotate(-90 230 69)",
    fill: "#F9CB2F",
    fillOpacity: 0.5
  })), _rect116 || (_rect116 = /*#__PURE__*/React.createElement("rect", {
    x: 230,
    y: 63,
    width: 2,
    height: 6,
    rx: 1,
    transform: "rotate(-90 230 63)",
    fill: "#F9CB2F",
    fillOpacity: 0.5
  })), _rect117 || (_rect117 = /*#__PURE__*/React.createElement("rect", {
    x: 230,
    y: 57,
    width: 2,
    height: 6,
    rx: 1,
    transform: "rotate(-90 230 57)",
    fill: "#F9CB2F",
    fillOpacity: 0.5
  })), _rect118 || (_rect118 = /*#__PURE__*/React.createElement("rect", {
    x: 230,
    y: 51,
    width: 2,
    height: 6,
    rx: 1,
    transform: "rotate(-90 230 51)",
    fill: "#F9CB2F",
    fillOpacity: 0.5
  })), _rect119 || (_rect119 = /*#__PURE__*/React.createElement("rect", {
    x: 230,
    y: 45,
    width: 2,
    height: 6,
    rx: 1,
    transform: "rotate(-90 230 45)",
    fill: "#F9CB2F",
    fillOpacity: 0.5
  })), _circle278 || (_circle278 = /*#__PURE__*/React.createElement("circle", {
    cx: 47.5,
    cy: 35.5,
    r: 1.5,
    fill: "#F9CB2F",
    fillOpacity: 0.5
  })), _circle279 || (_circle279 = /*#__PURE__*/React.createElement("circle", {
    cx: 47.5,
    cy: 220.5,
    r: 1.5,
    fill: "#F9CB2F",
    fillOpacity: 0.5
  })), _circle280 || (_circle280 = /*#__PURE__*/React.createElement("circle", {
    cx: 232.5,
    cy: 35.5,
    r: 1.5,
    fill: "#F9CB2F",
    fillOpacity: 0.5
  })), _circle281 || (_circle281 = /*#__PURE__*/React.createElement("circle", {
    cx: 232.5,
    cy: 220.5,
    r: 1.5,
    fill: "#F9CB2F",
    fillOpacity: 0.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M136.5 85.7321C138.356 84.6603 140.644 84.6603 142.5 85.7321L174.172 104.018C176.029 105.09 177.172 107.071 177.172 109.214V145.786C177.172 147.929 176.029 149.91 174.172 150.982L142.5 169.268C140.644 170.34 138.356 170.34 136.5 169.268L104.828 150.982C102.971 149.91 101.828 147.929 101.828 145.786V109.214C101.828 107.071 102.971 105.09 104.828 104.018L136.5 85.7321Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1_999",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 142,
    y: 103,
    width: 7,
    height: 6
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M142.569 106.035C142.569 107.478 143.911 108.652 145.561 108.652C147.211 108.652 148.553 107.478 148.553 106.035C148.553 104.592 147.211 103.418 145.561 103.418C143.911 103.418 142.569 104.592 142.569 106.035Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1_999)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M144.403 101L139.799 107.04L146.705 111.067L151.308 105.027L144.403 101Z",
    fill: "url(#paint2_linear_1_999)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_1_999",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 138,
    y: 107,
    width: 3,
    height: 3
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M138.749 108.652C138.749 109.138 139.202 109.534 139.758 109.534C140.313 109.534 140.766 109.138 140.766 108.652C140.766 108.166 140.313 107.77 139.758 107.77C139.202 107.77 138.749 108.166 138.749 108.652Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_1_999)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M139.366 106.96L137.815 108.995L140.141 110.351L141.691 108.317L139.366 106.96Z",
    fill: "url(#paint3_linear_1_999)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_1_999",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 131,
    y: 117,
    width: 15,
    height: 14
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M131.902 117.781C134.159 117.781 135.997 119.388 135.997 121.362C135.997 121.541 135.979 121.721 135.954 121.893C135.954 121.923 135.176 125.751 134.27 130.266C138.082 128.666 143.347 125.534 145.638 119.881C145.194 118.685 143.912 117.788 142.347 117.788H131.902V117.781Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_1_999)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M145.382 116.178L130 118L132.144 131.855L147.526 130.033L145.382 116.178Z",
    fill: "url(#paint4_linear_1_999)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask3_1_999",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 131,
    y: 121,
    width: 17,
    height: 32
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M134.672 130.992C134.526 131.051 134.313 131.141 134.073 131.238C132.8 137.541 131.347 144.719 131.347 144.719C131.227 145.638 130.936 148.846 133.244 150.894C137.808 154.947 148.014 150.416 147.886 149.302C147.835 148.846 146.031 149.062 144.125 147.545C143.108 146.73 142.484 145.765 142.27 145.414C141.826 144.681 141.527 143.956 141.33 143.32V143.298C141.347 143.216 141.364 143.134 141.381 143.051C141.638 136.091 143.022 129.063 145.629 121.975C142.98 126.708 138.321 129.474 134.672 130.992Z",
    fill: "white"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_1_999)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M148.017 121.842L130.598 121.978L130.935 155.083L148.354 154.947L148.017 121.842Z",
    fill: "url(#paint5_linear_1_999)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask4_1_999",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 131,
    y: 101,
    width: 17,
    height: 15
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M131.543 108.652C131.543 112.622 135.218 115.837 139.757 115.837C144.296 115.837 147.971 112.622 147.971 108.652C147.313 109.115 146.475 109.392 145.561 109.392C145.219 109.392 144.894 109.347 144.578 109.28C144.227 111.343 142.21 112.928 139.757 112.928C137.065 112.928 134.876 111.014 134.876 108.659C134.876 106.304 137.065 104.39 139.757 104.39C140.552 104.39 141.304 104.562 141.971 104.861C142.398 103.867 143.347 103.104 144.527 102.812C143.185 101.975 141.535 101.474 139.757 101.474C135.218 101.467 131.543 104.682 131.543 108.652Z",
    fill: "white"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask4_1_999)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M147.971 101.466H131.543V115.836H147.971V101.466Z",
    fill: "url(#paint6_linear_1_999)"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1_999",
    x: 0,
    y: 0,
    width: 280,
    height: 279,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 12
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 16
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.05 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1_999"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1_999",
    result: "shape"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_1_999",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(140 137) rotate(90) scale(90.5 89.9379)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAD930"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F4A428",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1_999",
    x1: 55,
    y1: 129,
    x2: 225,
    y2: 129,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7BC2C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F9D02F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1_999",
    x1: 148.529,
    y1: 105.718,
    x2: 142.249,
    y2: 116.487,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F2A427"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F9D834"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1_999",
    x1: 140.472,
    y1: 108.54,
    x2: 138.357,
    y2: 112.167,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F2A427"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F9D834"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_1_999",
    x1: 135.164,
    y1: 119.119,
    x2: 136.322,
    y2: 128.896,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F2A427"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F9D834"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_1_999",
    x1: 138.844,
    y1: 136.702,
    x2: 138.993,
    y2: 155.834,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F2A427"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F9D834"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_1_999",
    x1: 130.568,
    y1: 107.216,
    x2: 146.997,
    y2: 107.216,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F2A427"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F9D834"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInnovly);
export default __webpack_public_path__ + "static/media/innovly.12d2b9d134e74d3543ddc682fe70f003.svg";
export { ForwardRef as ReactComponent };